import { clearingApi } from "../../config/apiConfig";

// GET /clearing/bank-transactions
// params: { account?, from, to, direction?, search? }
// Returns the raw array of BankTransactionDto objects.
export const getBankTransactions = async (params = {}) => {
  try {
    const response = await clearingApi.get("bank-transactions", { params });
    return response.data;
  } catch (error) {
    console.error("Failed to fetch bank transactions.", error);
    throw error;
  }
};
